import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Table34 = {
  label: "四級&三級 異常及諮詢狀況",
  key: "Table34",
  path: "HealthAnalysisManagement/Table34",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.HealthAnalysisManagement.Table34 {...options} />
  ),
  // isColSum: true,
  // isRowSum: true,
  levelColumns,
  columns: [],
};
